import featureImage1 from "@/assets/newHome/01@2x.webp";
import featureDeco1 from "@/assets/newHome/group-3.png";

// import featureImage2 from "@/assets/newHome/02@2x.webp";
import featureImage2 from "@/assets/newHome/03@2x.webp";
import featureDeco2 from "@/assets/newHome/group-4.png";

import featureImage3 from "@/assets/newHome/04@2x.webp";
import featureDeco3 from "@/assets/newHome/group-5.png";

import featureImage4 from "@/assets/newHome/5@2x.webp";
import featureDeco4 from "@/assets/newHome/group-6.png";

// import featureImage5 from "@/assets/newHome/05@2x.webp";
import featureImage5 from "@/assets/newHome/quotes-kanban@2x.webp";
// import featureDeco5 from "@/assets/newHome/group-7.png";

import featureImage6 from "@/assets/newHome/06@2x.webp";
import TypewriterText from "@/components/animations/typewriter-text";
import Lottie from "lottie-react";
import arrowUpAnimation from "@/assets/animations/arrow-up-animation.json";

const options = {
  loop: true, // Set to false if you want the animation to play once
  autoplay: true, // Start the animation automatically
  animationData: arrowUpAnimation,
};

type BrowserCardProps = {
  image: string;
};
type FeatureCardProps = {
  label?: string;
  title?: string;
  description?: string;
  className?: string;
};
// Feature data for mapping
const features = [
  {
    label: "PROJECT LEADS",
    title: "Track Construction Activity from Permit Data",
    description:
      "We use permit data and online sources to deliver real-time insights on early-stage projects and the builders/developers involved.",
    image: featureImage1,
    decorationImage: featureDeco1,
    imageOnLeft: true,
  },
  {
    label: "AI POWER",
    title: "Data Insights and Recommendations with AI",
    description:
      "BuildMapper uses AI to analyze project data and your activity, recommending who to contact and when.",
    image: featureImage2,
    decorationImage: featureDeco2,
    imageOnLeft: false,
  },
  {
    label: "CRM",
    title: "Manage Leads from Start to Close",
    description:
      "Track every lead, follow-up, and view your pipeline with a CRM built for how construction teams actually sell.",
    image: featureImage3,
    decorationImage: featureDeco3,
    imageOnLeft: true,
  },
  {
    label: "AUTOMATED WORKFLOW",
    title: "Set-and-Forget Sales Task Automation",
    description:
      "Let BuildMapper handle the busywork by finding leads, sending emails, and scheduling follow-up as your leads move through the pipeline.",
    image: featureImage4,
    decorationImage: featureDeco4,
    imageOnLeft: false,
  },
  {
    label: "DOCUMENTS",
    title: "Create Quotes, Contracts, and Invoices",
    description:
      "Quickly generate and send professional quotes, contracts, and invoices — all from one place.",
    image: featureImage5,
    // decorationImage: featureDeco5,
    imageOnLeft: true,
  },
  {
    label: "SALES ANALYTICS",
    title: "Close Deals & Track Results",
    description:
      "Get a clear view of calls made, deals closed, and team performance — all in one dashboard.",
    image: featureImage6,
    decorationImage: null,
    imageOnLeft: false,
  },
];

export const ProcessByAnima = (): JSX.Element => {
  return (
    <section className="w-full bg-white md:pb-18 lg:pb-[7rem] xl:pb-[5rem] pb-8">
      <div className="pt-16 lg:w-[89%] md:w-[90%] w-[80%] sm:w-[90%]  mx-auto bg-white lg:py-  ">
      <h2 className="xl:text-3xl md:text-xl text-lg font-semibold opacity-0 absolute whitespace-pre-wrap pointer-events-none">
    <span className="text-charcoal">From Permits to Proposals</span>
    <br />
    <span className="text-charcoal">The </span>
    <span className="text-primary">Sales Engine </span>
    <span className="text-charcoal">For Construction</span>
  </h2>
        <div className=" sm:mb-12 mt-4 min-h-[96px]">
          {/* <h2 className="md:text-4xl text-lg font-semibold">
          <span className="text-charcoal">Sales Made Simple for </span>
          <span className="text-primary">
            Subcontractors
            <br />
          </span>
          <span className="text-charcoal">and </span>
          <span className="text-primary">Building Suppliers</span>
        </h2> */}

          <TypewriterText
            fullTextParts={[
              {
                text: "From Permits to Proposals\n",
                className: "text-charcoal",
              },
              { text: "The ", className: "text-charcoal" },
              { text: "Sales Engine ", className: "text-primary" },
              { text: "For Construction", className: "text-charcoal" },
            ]}
          />
        </div>

        {features.map((feature, index) => (
          <div
            key={index}
            className={`flex sm:flex-row ${
              !feature.imageOnLeft ? "flex-col-reverse" : "flex-col"
            } items-center  mx-auto lg:gap-10 md:gap-12 sm:gap-4 w-full relative ${index == features.length - 1 ? "" : "md:mb-18 lg:mb-[7rem] xl:mb-[5rem] mb-8"}`}
          >
            {feature.imageOnLeft ? (
              <>
                <BrowserCard
                  image={feature.image}
                  // className="w-[40%]"
                />
                <FeatureContent
                  label={feature.label}
                  title={feature.title}
                  description={feature.description}
                  className="flex-1 w-[114%] md:w-[50%] sm:w-[50%] xl:w-[30%] lg:w-[40%]"
                />
                {/* {feature.decorationImage && (
                <img
                  className="hidden sm:flex absolute w-[12%] h-[35%] sm:w-[12%] sm:h-[35%] md:h-[22%] md:w-[6%] lg:w-[12%] lg:h-[35%] xl:w-[12%] xl:h-[35%] 2xl:w-[12%] 2xl:h-[35%] bottom-20  xl:left-[59.9%] lg:left-[55%] 
                  md:left-[50%] sm:left-[58%] -translate-x-1/2 md:translate-x-0 md:bottom-auto  top-[11.5rem] 
                  xl:top-[20.5rem] 2xl:top-[24rem] lg:top-[16rem] md:top-[12rem]"
                  alt=""
                  src={feature.decorationImage}
                />
              )} */}
                <div
                  className=" hidden left-arrow absolute -translate-x-1/2 
                  lg:flex lg:w-[10%] lg:h-[45%] lg:left-[46%] lg:top-[90%]
                  xl:left-[48%] xl:w-[10%] xl:h-[45%] xl:top-[82%]
                  2xl:w-[10%] 2xl:h-[45%]  2xl:top-[82%]  2xl:left-[45%]
                  
                  "
                >
                  <Lottie {...options} />
                </div>
              </>
            ) : (
              <>
                <FeatureContent
                  label={feature.label}
                  title={feature.title}
                  description={feature.description}
                  className="flex-1 w-[114%] xl:w-[30%] lg:w-[30%] md:w-[30%] sm:w-[50%]"
                />
                <BrowserCard image={feature.image} />
                {/* {feature.decorationImage && (
                <img
                  className="hidden sm:flex absolute w-[12%] h-[45%] sm:w-[12%] sm:h-[45%] md:h-[22%] md:w-[6%] lg:w-[12%] lg:h-[45%] xl:w-[12%] xl:h-[45%] 2xl:w-[12%] 2xl:h-[45%] -bottom-20  xl:left-[27.9%] lg:left-[33%] md:left-[44%] 
                  sm:left-[40%] -translate-x-1/2 md:translate-x-0 md:bottom-auto xl:top-[18rem] 2xl:top-[21rem] lg:top-[15rem] 
                  md:top-[10.5rem] sm:top-[11.5rem] top-[12rem]"
                  alt=""
                  src={feature.decorationImage}
                />
              )} */}
                {feature.decorationImage && (
                  <div
                    className="stroke-[2rem] absolute
                    -translate-x-1/2  hidden 
                    lg:flex lg:h-[45%] lg:w-[10%] lg:top-[18rem] lg:left-[38%] 
                    xl:w-[10%] xl:h-[45%] xl:top-[82%]  xl:left-[48%] 
                    2xl:w-[10%] 2xl:h-[35%] 2xl:top-[86%] 2xl:left-[47%] 
                    "
                  >
                    <Lottie {...options} />
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

// Browser-like card component
// // @ts-expect-error
const BrowserCard = ({ image }: BrowserCardProps) => (
  // <Card className={`shadow-[0px_3.6px_44.96px_#0000001a] ${className}`}>
  //   <CardContent className="p-0">
  <div className="xl:w-[60%] lg:w-[55%] md:w-[50%] sm:w-[55%] w-[150%]">
    {/* <div className="absolute w-full h-[23px] top-0 left-0 bg-[#eaeaea99]/60 rounded-t-[7.32px] backdrop-blur-[25.76px] backdrop-brightness-[100%]">
          <div className="flex items-center h-full pl-5 gap-[17px]">
            <div className="w-[9px] h-[9px] bg-[#ee6666] rounded-full" />
            <div className="w-[9px] h-[9px] bg-[#f6c566] rounded-full" />
            <div className="w-[9px] h-[9px] bg-[#5bea7a] rounded-full" />
          </div>
        </div> */}

    <img
      className=" ml-16 sm:mx-0 sm:w-full h-auto object-cover rounded-[7.32px] "
      alt="Screenshot of feature"
      src={image}
    />
  </div>
  //     </CardContent>
  //   </Card>
);

// Feature content component
// const FeatureContent = ({ label, title, description,className }: FeatureCardProps) => (
//   <div className={`flex flex-col xl:gap-3 gap-2 ${className}`}>
//     <span className="lg:text-xl md:text-md font-semibold text-primary">{label}</span>
//     <div className="xl:w-[83%] lg:w-[96%] md:w-[95%] ">
//     <h3 className="lg:text-3xl md:text-xl text-xl font-semibold text-charcoal">{title}</h3>
//     </div>

//     <p className="lg:text-xl text-md text-gray-700">{description}</p>
//   </div>
// );
const FeatureContent = ({
  label,
  title,
  description,
  className,
}: FeatureCardProps) => (
  <div className={`mt-5 sm:mt-0 flex flex-col  xl:gap-3 gap-2 ${className}`}>
    <span className="lg:text-xl text-[18px] text-left md:text-md font-semibold text-primary">
      {label}
    </span>
    <div className="w-[96%] xl:w-[83%] lg:w-[96%] text-left md:w-[95%]">
      <h3 className="text-2xl leading-[31.2px] lg:text-3xl md:text-xl text-left   sm:leading-none sm:text-xl font-semibold text-charcoal">
        {title}
      </h3>
    </div>

    <p className="lg:text-xl text-base text-left text-[#0d121f]">
      {description}
    </p>
    <hr className="w-full mt-4 sm:hidden" />
  </div>
);


